import TextField from '../Reusable/Form/TextInput'

const CustomerForm = ({ register, errors, setValue, clearErrors }: any) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4">
    <TextField
      label={"Full Name"}
      register={register("full_name")}
      errors={errors?.full_name}
    />
    <TextField
      label={"Email"}
      register={register("email")}
      errors={errors?.email}
    />
    <TextField
      label={"Mobile Number"}
      register={register("mobile_number")}
      errors={errors?.mobile_number}
    />
    <TextField
      label={"Alt Number"}
      register={register("secondary_contact")}
      errors={errors?.secondary_contact}
    />
    <TextField
      label={"Full Address"}
      register={register("address")}
      errors={errors?.address}
    />
    <TextField
      label={"VAT/PAN"}
      register={register("vat_pan")}
      errors={errors?.vat_pan}
    />

  </div>
  )
}

export default CustomerForm
